webpackJsonp([1],{

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'screensize',
  computed: {
    sw: function sw() {
      return window.screen.width;
    },
    sh: function sh() {
      return window.screen.height;
    }
  }
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Controls__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['version'])),
  components: {
    mzControls: __WEBPACK_IMPORTED_MODULE_1__components_Controls__["a" /* default */]
  }
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Connect__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Disconnect__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//







var debug = window.debug('mz-controls');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'controls',
  data: function data() {
    return {
      device: null
    };
  },

  components: {
    mzConnect: __WEBPACK_IMPORTED_MODULE_1__components_Connect__["a" /* default */],
    mzDisconnect: __WEBPACK_IMPORTED_MODULE_2__components_Disconnect__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['connected', 'currentVib', 'currentLife'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])(['setConnected', 'updateHistory', 'updateLife']), {
    dateString: function dateString(d, fmt) {
      fmt = fmt || 'HH:mm:ss';
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(d).format(fmt);
    }
  }),
  created: function created() {
    var _this = this;

    this.device = window.mzBleDevice;

    this.device.on('connected', function () {
      _this.setConnected(true);
      _this.device.start();
      _this.$store.state.connectedAt = Date.now();
    });

    this.device.on('disconnected', function () {
      _this.setConnected(false);
      _this.$store.state.disconnectedAt = Date.now();
    });

    this.device.on('data', function (msg) {
      debug(msg);
      _this.updateHistory({ tag: 'vib', point: { x: new Date(msg.ts), y: msg.vib } });
      _this.updateHistory({ tag: 'temp', point: { x: new Date(msg.ts), y: msg.temp } });

      _this.updateLife({ currentLife: _this.currentLife, currentVib: _this.currentVib });

      _this.$store.state.updatedAt = Date.now();
    });
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'connect',
  props: ['device'],
  data: function data() {
    return {
      defaultLabel: 'Connect',
      progressLabel: 'Connecting',
      icon: 'link',
      spinner: 'spinner',
      inProgress: false
    };
  },

  computed: {
    label: function label() {
      return this.device.isConnecting ? this.progressLabel : this.defaultLabel;
    }
  },
  methods: {
    action: function action(e) {
      e.target.blur();

      this.device.connect();
    }
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'disconnect',
  props: ['device'],
  data: function data() {
    return {
      connected: false,
      label: 'Disconnect',
      icon: 'unlink'
    };
  },

  methods: {
    action: function action(e) {
      e.target.blur();

      var p = this.device.stop();
      p.finally(this.device.disconnect);
    }
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Status__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Lifetime__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Vibration__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Temperature__ = __webpack_require__(351);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      msg: 'Welcome to Your MOZYS PWA'
    };
  },

  components: {
    mzStatus: __WEBPACK_IMPORTED_MODULE_0__components_Status__["a" /* default */],
    mzLifetime: __WEBPACK_IMPORTED_MODULE_1__components_Lifetime__["a" /* default */],
    mzVibration: __WEBPACK_IMPORTED_MODULE_2__components_Vibration__["a" /* default */],
    mzTemperature: __WEBPACK_IMPORTED_MODULE_3__components_Temperature__["a" /* default */]
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'status',
  data: function data() {
    return {
      context: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['currentLevel']))
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lifetime',
  data: function data() {
    return {
      chart: null,
      config: {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [0, 100],
            borderWidth: 0
          }]
        },
        options: {
          cutoutPercentage: 75,
          events: []
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['levelColors', 'level', 'currentLife', 'colors']), {
    currentLifeLevel: function currentLifeLevel() {
      return this.level.life;
    }
  }),
  watch: {
    currentLife: function currentLife() {
      this.setColor(this.levelColors[this.currentLifeLevel]);
      this.updateChart();
    }
  },
  methods: {
    setColor: function setColor(color) {
      this.config.data.datasets[0].backgroundColor = [color, this.colors.light];
    },
    createChart: function createChart() {
      this.setColor(this.levelColors[0]);
      var ctx = document.getElementById('lifetime-chart-area').getContext('2d');
      this.chart = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, this.config);
    },
    updateChart: function updateChart() {
      var val = Math.round(Math.min(this.currentLife, 100));
      this.chart.data.datasets[0].data = [val, 100 - val];
      this.chart.update();
    }
  },
  mounted: function mounted() {
    this.createChart();
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_chart_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vibration',
  data: function data() {
    return {
      chart: null,
      config: {
        type: 'line',
        data: {
          datasets: [{
            data: [1, 1, 1, 1],
            fill: false,
            lineTension: 0,
            borderColor: 'rgb(36, 64, 107)'
          }],
          yHighlightRange: [{
            begin: 0,
            end: 1.2,
            backgroundColor: 'rgba(143, 251, 175, 0.1)'
          }, {
            begin: 1.2,
            end: 1.5,
            backgroundColor: 'rgba(255, 255, 102, 0.1)'
          }, {
            begin: 1.5,
            end: 2.0,
            backgroundColor: 'rgba(219, 54, 69, 0.1)'
          }]
        },
        options: {
          responsive: true,
          events: [],
          animation: false,
          elements: {
            point: {
              backgroundColor: 'rgb(36, 64, 107)'
            }
          },
          title: {
            display: false
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'second',
                displayFormats: {
                  second: 'HH:mm:ss'
                }
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                stepSize: 0.5,
                min: 0,
                max: 2
              }
            }]
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['colors', 'history', 'thresh']), {
    vibData: function vibData() {
      return this.history.vib;
    }
  }),
  watch: {
    vibData: function vibData() {
      this.chart.data.datasets[0].data = this.vibData;
      this.chart.update();
    }
  },
  methods: {
    createChart: function createChart() {
      var ctx = document.getElementById('vib-chart-area').getContext('2d');
      this.chart = new __WEBPACK_IMPORTED_MODULE_1__lib_chart_js__["a" /* default */](ctx, this.config);
    }
  },
  mounted: function mounted() {
    this.createChart();
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);


var originalLineDraw = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.controllers.line.prototype.draw;
__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.helpers.extend(__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.controllers.line.prototype, {
        draw: function draw() {
                var chart = this.chart;

                var yHighlightRangeArray = chart.config.data.yHighlightRange || [];
                yHighlightRangeArray.forEach(function (yHighlightRange) {
                        if (yHighlightRange !== undefined) {
                                var ctx = chart.chart.ctx;

                                var yRangeBegin = yHighlightRange.begin;
                                var yRangeEnd = yHighlightRange.end;

                                var xaxis = chart.scales['x-axis-0'];
                                var yaxis = chart.scales['y-axis-0'];

                                var yRangeBeginPixel = yaxis.getPixelForValue(yRangeBegin);
                                var yRangeEndPixel = yaxis.getPixelForValue(yRangeEnd);

                                ctx.save();

                                ctx.fillStyle = yHighlightRange.backgroundColor;

                                ctx.fillRect(xaxis.left, Math.min(yRangeBeginPixel, yRangeEndPixel), xaxis.right - xaxis.left, Math.max(yRangeBeginPixel, yRangeEndPixel) - Math.min(yRangeBeginPixel, yRangeEndPixel));
                                ctx.restore();
                        }
                });

                originalLineDraw.apply(this, arguments);
        }
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a);

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_chart_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'temperature',
  data: function data() {
    return {
      chart: null,
      config: {
        type: 'line',
        data: {
          datasets: [{
            data: [1, 1, 1, 1],
            fill: false,
            lineTension: 0,
            borderColor: 'rgb(36, 64, 107)'
          }],
          yHighlightRange: [{
            begin: 0,
            end: 35,
            backgroundColor: 'rgba(143, 251, 175, 0.1)'
          }, {
            begin: 35,
            end: 40,
            backgroundColor: 'rgba(255, 255, 102, 0.1)'
          }, {
            begin: 40,
            end: 50,
            backgroundColor: 'rgba(219, 54, 69, 0.1)'
          }]
        },
        options: {
          responsive: true,
          events: [],
          animation: false,
          elements: {
            point: {
              backgroundColor: 'rgb(36, 64, 107)'
            }
          },
          title: {
            display: false
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'second',
                displayFormats: {
                  second: 'HH:mm:ss'
                }
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                stepSize: 10,
                min: 0,
                max: 50
              }
            }]
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['colors', 'history', 'thresh']), {
    tempData: function tempData() {
      return this.history.temp;
    }
  }),
  watch: {
    tempData: function tempData() {
      this.chart.data.datasets[0].data = this.tempData;
      this.chart.update();
    }
  },
  methods: {
    createChart: function createChart() {
      var ctx = document.getElementById('temp-chart-area').getContext('2d');
      this.chart = new __WEBPACK_IMPORTED_MODULE_1__lib_chart_js__["a" /* default */](ctx, this.config);
    }
  },
  mounted: function mounted() {
    this.createChart();
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_js_dist_collapse__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_js_dist_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_js_dist_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_debug__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_ble__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_pro_solid_svg_icons__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__ = __webpack_require__(358);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




//
// import '@/lib/jquery/1.12.4/jquery.min'
// import '@/lib/flot/0.8.3/jquery.flot.min'
// import '@/lib/flot/0.8.3/jquery.flot.time.min'
// import '@/lib/flot/0.8.3/jquery.flot.pie.min'
//





__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["r" /* faThermometerHalf */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["l" /* faHeartbeat */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["c" /* faChartLine */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["v" /* faToggleOn */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["u" /* faToggleOff */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_pro_solid_svg_icons__["b" /* faHeartRate */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_pro_solid_svg_icons__["e" /* faTachometer */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["b" /* faCalendarAlt */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["i" /* faClock */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["a" /* faBolt */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["n" /* faRedo */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["t" /* faTint */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["x" /* faWater */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_pro_solid_svg_icons__["d" /* faOilTemp */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_pro_solid_svg_icons__["c" /* faOilCan */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_pro_solid_svg_icons__["a" /* faCommentAltExclamation */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["q" /* faStethoscope */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["m" /* faLink */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["w" /* faUnlink */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["p" /* faSpinner */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["o" /* faSortDown */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["h" /* faClipboardCheck */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["j" /* faCogs */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["f" /* faChevronLeft */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["s" /* faTimes */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["d" /* faCheck */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["k" /* faExclamation */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["y" /* faWrench */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["e" /* faChevronDown */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["g" /* faChevronUp */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('fa-icon', __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
var require;var require;

!function (e) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports)) && "undefined" != typeof module) module.exports = e();else if ("function" == typeof define && __webpack_require__(243)) define([], e);else {
    var n;n = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, n.debug = e();
  }
}(function () {
  return function e(n, r, t) {
    function o(i, c) {
      if (!r[i]) {
        if (!n[i]) {
          var a = "function" == typeof require && require;if (!c && a) return require(i, !0);if (s) return s(i, !0);var u = new Error("Cannot find module '" + i + "'");throw u.code = "MODULE_NOT_FOUND", u;
        }var f = r[i] = { exports: {} };n[i][0].call(f.exports, function (e) {
          var r = n[i][1][e];return o(r ? r : e);
        }, f, f.exports, e, n, r, t);
      }return r[i].exports;
    }for (var s = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }({ 1: [function (e, n, r) {
      function t() {
        throw new Error("setTimeout has not been defined");
      }function o() {
        throw new Error("clearTimeout has not been defined");
      }function s(e) {
        if (l === setTimeout) return setTimeout(e, 0);if ((l === t || !l) && setTimeout) return l = setTimeout, setTimeout(e, 0);try {
          return l(e, 0);
        } catch (n) {
          try {
            return l.call(null, e, 0);
          } catch (n) {
            return l.call(this, e, 0);
          }
        }
      }function i(e) {
        if (d === clearTimeout) return clearTimeout(e);if ((d === o || !d) && clearTimeout) return d = clearTimeout, clearTimeout(e);try {
          return d(e);
        } catch (n) {
          try {
            return d.call(null, e);
          } catch (n) {
            return d.call(this, e);
          }
        }
      }function c() {
        g && m && (g = !1, m.length ? h = m.concat(h) : y = -1, h.length && a());
      }function a() {
        if (!g) {
          var e = s(c);g = !0;for (var n = h.length; n;) {
            for (m = h, h = []; ++y < n;) {
              m && m[y].run();
            }y = -1, n = h.length;
          }m = null, g = !1, i(e);
        }
      }function u(e, n) {
        this.fun = e, this.array = n;
      }function f() {}var l,
          d,
          p = n.exports = {};!function () {
        try {
          l = "function" == typeof setTimeout ? setTimeout : t;
        } catch (e) {
          l = t;
        }try {
          d = "function" == typeof clearTimeout ? clearTimeout : o;
        } catch (e) {
          d = o;
        }
      }();var m,
          h = [],
          g = !1,
          y = -1;p.nextTick = function (e) {
        var n = new Array(arguments.length - 1);if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }h.push(new u(e, n)), 1 !== h.length || g || s(a);
      }, u.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = f, p.addListener = f, p.once = f, p.off = f, p.removeListener = f, p.removeAllListeners = f, p.emit = f, p.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, p.cwd = function () {
        return "/";
      }, p.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, p.umask = function () {
        return 0;
      };
    }, {}], 2: [function (e, n, r) {
      function t(e) {
        if (e = String(e), !(e.length > 100)) {
          var n = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);if (n) {
            var r = parseFloat(n[1]),
                t = (n[2] || "ms").toLowerCase();switch (t) {case "years":case "year":case "yrs":case "yr":case "y":
                return r * l;case "days":case "day":case "d":
                return r * f;case "hours":case "hour":case "hrs":case "hr":case "h":
                return r * u;case "minutes":case "minute":case "mins":case "min":case "m":
                return r * a;case "seconds":case "second":case "secs":case "sec":case "s":
                return r * c;case "milliseconds":case "millisecond":case "msecs":case "msec":case "ms":
                return r;default:
                return;}
          }
        }
      }function o(e) {
        return e >= f ? Math.round(e / f) + "d" : e >= u ? Math.round(e / u) + "h" : e >= a ? Math.round(e / a) + "m" : e >= c ? Math.round(e / c) + "s" : e + "ms";
      }function s(e) {
        return i(e, f, "day") || i(e, u, "hour") || i(e, a, "minute") || i(e, c, "second") || e + " ms";
      }function i(e, n, r) {
        if (!(e < n)) return e < 1.5 * n ? Math.floor(e / n) + " " + r : Math.ceil(e / n) + " " + r + "s";
      }var c = 1e3,
          a = 60 * c,
          u = 60 * a,
          f = 24 * u,
          l = 365.25 * f;n.exports = function (e, n) {
        n = n || {};var r = typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e);if ("string" === r && e.length > 0) return t(e);if ("number" === r && isNaN(e) === !1) return n.long ? s(e) : o(e);throw new Error("val is not a non-empty string or a valid number. val=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
      };
    }, {}], 3: [function (e, n, r) {
      function t(e) {
        var n,
            t = 0;for (n in e) {
          t = (t << 5) - t + e.charCodeAt(n), t |= 0;
        }return r.colors[Math.abs(t) % r.colors.length];
      }function o(e) {
        function n() {
          if (n.enabled) {
            var e = n,
                t = +new Date(),
                o = t - (u || t);e.diff = o, e.prev = u, e.curr = t, u = t;for (var s = new Array(arguments.length), i = 0; i < s.length; i++) {
              s[i] = arguments[i];
            }s[0] = r.coerce(s[0]), "string" != typeof s[0] && s.unshift("%O");var c = 0;s[0] = s[0].replace(/%([a-zA-Z%])/g, function (n, t) {
              if ("%%" === n) return n;c++;var o = r.formatters[t];if ("function" == typeof o) {
                var i = s[c];n = o.call(e, i), s.splice(c, 1), c--;
              }return n;
            }), r.formatArgs.call(e, s);var a = n.log || r.log || console.log.bind(console);a.apply(e, s);
          }
        }return n.namespace = e, n.enabled = r.enabled(e), n.useColors = r.useColors(), n.color = t(e), "function" == typeof r.init && r.init(n), n;
      }function s(e) {
        r.save(e), r.names = [], r.skips = [];for (var n = ("string" == typeof e ? e : "").split(/[\s,]+/), t = n.length, o = 0; o < t; o++) {
          n[o] && (e = n[o].replace(/\*/g, ".*?"), "-" === e[0] ? r.skips.push(new RegExp("^" + e.substr(1) + "$")) : r.names.push(new RegExp("^" + e + "$")));
        }
      }function i() {
        r.enable("");
      }function c(e) {
        var n, t;for (n = 0, t = r.skips.length; n < t; n++) {
          if (r.skips[n].test(e)) return !1;
        }for (n = 0, t = r.names.length; n < t; n++) {
          if (r.names[n].test(e)) return !0;
        }return !1;
      }function a(e) {
        return e instanceof Error ? e.stack || e.message : e;
      }r = n.exports = o.debug = o.default = o, r.coerce = a, r.disable = i, r.enable = s, r.enabled = c, r.humanize = e("ms"), r.names = [], r.skips = [], r.formatters = {};var u;
    }, { ms: 2 }], 4: [function (e, n, r) {
      (function (t) {
        function o() {
          return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type) || "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
        }function s(e) {
          var n = this.useColors;if (e[0] = (n ? "%c" : "") + this.namespace + (n ? " %c" : " ") + e[0] + (n ? "%c " : " ") + "+" + r.humanize(this.diff), n) {
            var t = "color: " + this.color;e.splice(1, 0, t, "color: inherit");var o = 0,
                s = 0;e[0].replace(/%[a-zA-Z%]/g, function (e) {
              "%%" !== e && (o++, "%c" === e && (s = o));
            }), e.splice(s, 0, t);
          }
        }function i() {
          return "object" == (typeof console === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
        }function c(e) {
          try {
            null == e ? r.storage.removeItem("debug") : r.storage.debug = e;
          } catch (e) {}
        }function a() {
          var e;try {
            e = r.storage.debug;
          } catch (e) {}return !e && "undefined" != typeof t && "env" in t && (e = t.env.DEBUG), e;
        }function u() {
          try {
            return window.localStorage;
          } catch (e) {}
        }r = n.exports = e("./debug"), r.log = i, r.formatArgs = s, r.save = c, r.load = a, r.useColors = o, r.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : u(), r.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"], r.formatters.j = function (e) {
          try {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e);
          } catch (e) {
            return "[UnexpectedJSONParseError]: " + e.message;
          }
        }, r.enable(a());
      }).call(this, e("_process"));
    }, { "./debug": 3, _process: 1 }] }, {}, [4])(4);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(218)(module), __webpack_require__(21)))

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


(function () {
  try {
    var log = debug('mz-ble-device');
  } catch (err) {
    var log = function log() {};
  }

  log('loaded');

  // -----------------------------------------------------------------
  // BLE
  // -----------------------------------------------------------------
  var serviceUuid = "0000ffe0-0000-1000-8000-00805f9b34fb";
  var characteristicUuid = "0000ffe1-0000-1000-8000-00805f9b34fb";
  var bleCharacteristic = null;
  var bleDevice = null;

  var startCode = 'S';
  var stopCode = 'E';
  var littleEndian = true;

  var dataLength = 5;

  var vibExtIdx = 0;
  var tempIdx = 1;
  var vibIdx = 2;

  var bytesPerElement = Float32Array.BYTES_PER_ELEMENT;
  var byteLength = dataLength * bytesPerElement;

  // -----------------------------------------------------------------

  var ts0;

  var mzBleDevice = window.mzBleDevice = {
    connected: false,
    isConnecting: false,
    events: {},
    eventLabels: ['connected', 'disconnected', 'started', 'stopped', 'data']
  };

  mzBleDevice.eventLabels.forEach(function (label) {
    mzBleDevice.events[label] = [];
  });

  mzBleDevice.options = {
    warn: 1.2,
    alarm: 1.5
  };

  mzBleDevice.connect = function (options) {
    log('mzBleDevice#connect');

    options = options || {};
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options).forEach(function (key) {
      mzBleDevice.options[key] = options[key];
    });

    if (!navigator.bluetooth) {
      return alert('your browser does not support bluetooth!');
    }

    _connect(mzBleDevice.options);
  };

  mzBleDevice.disconnect = function () {
    log('mzBleDevice#disconnect');

    _disconnect();
  };

  mzBleDevice.start = function () {
    log('mzBleDevice#start');

    if (!mzBleDevice.connected) {
      log('mzBleDevice is not connected');
      return;
    }

    _start();
  };

  mzBleDevice.stop = function () {
    log('mzBleDevice#stop');

    if (!mzBleDevice.connected) {
      log('mzBleDevice is not connected');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('device is not connected'));
    }

    return _stop();
  };

  mzBleDevice.on = function (event, eventCallback) {
    if (mzBleDevice.events[event] !== undefined) {
      mzBleDevice.events[event].push(eventCallback);
      return log('event registered:', event);
    }

    log('unkown event: ' + event);
  };

  function _connect(options) {
    log('_connect');

    navigator.bluetooth.requestDevice({ filters: [{ services: [serviceUuid] }] }).then(function (_device) {
      log('connecting to GATT server...');
      bleDevice = _device;
      mzBleDevice.isConnecting = true;
      bleDevice.addEventListener('gattserverdisconnected', _disconnectCallback);
      return bleDevice.gatt.connect();
    }).then(function (server) {
      log('getting service...');
      // return server.getPrimaryService(serviceUuid);
      return server.getPrimaryServices();
    }).then(function (services) {
      // log('listing services...');
      var service = services.filter(function (_service) {
        log('> Service: ' + _service.uuid);
        return _service.uuid === serviceUuid;
      })[0];

      if (!service) {
        throw 'service not found';
      }

      log('getting characteristic...');
      return service.getCharacteristic(characteristicUuid);
    }).then(function (characteristic) {
      bleCharacteristic = characteristic;
      return bleCharacteristic.startNotifications().then(function (_) {
        log('notifications started...');
        bleCharacteristic.addEventListener('characteristicvaluechanged', _notificationCallback);

        _connectCallback();
      });
    }).catch(function (err) {
      mzBleDevice.isConnecting = false;
      log('arrrgh! ' + err);
    });
  }

  function _notificationCallback(event) {
    log('_notificationCallback');

    var val = event.target.value;

    var rawData = [];
    var err = null;

    log('bytes received: ' + val.byteLength);

    for (var j = 0; j < dataLength; j++) {
      rawData.push(val.getFloat32(j * bytesPerElement, littleEndian));
    }

    _parseData(rawData);
  }

  function _parseData(rawData) {
    var ts = Date.now();
    if (ts0 === undefined) {
      ts0 = ts;
    }

    var t = (ts - ts0) / 1000;

    var vib = rawData[vibIdx];
    var vibExt = rawData[vibExtIdx];
    var temp = rawData[tempIdx];

    var warn = false;
    var alarm = false;

    if (vib > mzBleDevice.options.alarm || vibExt > mzBleDevice.options.alarm) {
      alarm = true;
    } else if (vib > mzBleDevice.options.warn || vibExt > mzBleDevice.options.warn) {
      warn = true;
    }

    var data = {
      ts: ts,
      vib: vib,
      vibExt: vibExt,
      temp: temp,
      warn: warn,
      alarm: alarm
    };

    if (mzBleDevice.connected) {
      mzBleDevice.events.data.forEach(function (cb) {
        cb(data);
      });
    }
  }

  function _connectCallback() {
    log('_connectCallback');

    mzBleDevice.connected = true;
    mzBleDevice.isConnecting = false;
    mzBleDevice.events.connected.forEach(function (cb) {
      cb(mzBleDevice.running);
    });
  }

  function _disconnectCallback() {
    log('_disconnectCallback');

    mzBleDevice.connected = false;
    mzBleDevice.isConnecting = false;
    mzBleDevice.events.disconnected.forEach(function (cb) {
      cb();
    });
  }

  function _disconnect() {
    log('_disconnect');

    if (bleDevice.gatt.connected) {
      return bleDevice.gatt.disconnect();
    }

    log('bleDevice is already disconnected');
  }

  function _start() {
    log('_start');

    if (!bleCharacteristic) {
      log('no characteristic... canceled');
      return;
    }

    bleCharacteristic.writeValue(Uint8Array.of(startCode.charCodeAt(0))).then(function (_) {
      log('sent startCode: ' + startCode);
    }).catch(function (err) {
      log('[ERROR] could not send startCode: ' + err);
    });
  }

  function _stop() {
    log('_stop');

    if (!bleCharacteristic) {
      log('no characteristic... canceled');
      return;
    }

    return bleCharacteristic.writeValue(Uint8Array.of(stopCode.charCodeAt(0))).then(function (_) {
      log('sent stopCode: ' + stopCode);
    }).catch(function (err) {
      log('[ERROR] could not send stopCode: ' + err);
    });
  }
})();

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1feedca0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1feedca0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debug_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d03713_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debug_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67d03713"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debug_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d03713_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateDisplay_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6128393c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateDisplay_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateDisplay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6128393c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateDisplay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 70,
	"./af.js": 70,
	"./ar": 71,
	"./ar-dz": 72,
	"./ar-dz.js": 72,
	"./ar-kw": 73,
	"./ar-kw.js": 73,
	"./ar-ly": 74,
	"./ar-ly.js": 74,
	"./ar-ma": 75,
	"./ar-ma.js": 75,
	"./ar-sa": 76,
	"./ar-sa.js": 76,
	"./ar-tn": 77,
	"./ar-tn.js": 77,
	"./ar.js": 71,
	"./az": 78,
	"./az.js": 78,
	"./be": 79,
	"./be.js": 79,
	"./bg": 80,
	"./bg.js": 80,
	"./bm": 81,
	"./bm.js": 81,
	"./bn": 82,
	"./bn.js": 82,
	"./bo": 83,
	"./bo.js": 83,
	"./br": 84,
	"./br.js": 84,
	"./bs": 85,
	"./bs.js": 85,
	"./ca": 86,
	"./ca.js": 86,
	"./cs": 87,
	"./cs.js": 87,
	"./cv": 88,
	"./cv.js": 88,
	"./cy": 89,
	"./cy.js": 89,
	"./da": 90,
	"./da.js": 90,
	"./de": 91,
	"./de-at": 92,
	"./de-at.js": 92,
	"./de-ch": 93,
	"./de-ch.js": 93,
	"./de.js": 91,
	"./dv": 94,
	"./dv.js": 94,
	"./el": 95,
	"./el.js": 95,
	"./en-au": 96,
	"./en-au.js": 96,
	"./en-ca": 97,
	"./en-ca.js": 97,
	"./en-gb": 98,
	"./en-gb.js": 98,
	"./en-ie": 99,
	"./en-ie.js": 99,
	"./en-il": 100,
	"./en-il.js": 100,
	"./en-nz": 101,
	"./en-nz.js": 101,
	"./eo": 102,
	"./eo.js": 102,
	"./es": 103,
	"./es-do": 104,
	"./es-do.js": 104,
	"./es-us": 105,
	"./es-us.js": 105,
	"./es.js": 103,
	"./et": 106,
	"./et.js": 106,
	"./eu": 107,
	"./eu.js": 107,
	"./fa": 108,
	"./fa.js": 108,
	"./fi": 109,
	"./fi.js": 109,
	"./fo": 110,
	"./fo.js": 110,
	"./fr": 111,
	"./fr-ca": 112,
	"./fr-ca.js": 112,
	"./fr-ch": 113,
	"./fr-ch.js": 113,
	"./fr.js": 111,
	"./fy": 114,
	"./fy.js": 114,
	"./gd": 115,
	"./gd.js": 115,
	"./gl": 116,
	"./gl.js": 116,
	"./gom-latn": 117,
	"./gom-latn.js": 117,
	"./gu": 118,
	"./gu.js": 118,
	"./he": 119,
	"./he.js": 119,
	"./hi": 120,
	"./hi.js": 120,
	"./hr": 121,
	"./hr.js": 121,
	"./hu": 122,
	"./hu.js": 122,
	"./hy-am": 123,
	"./hy-am.js": 123,
	"./id": 124,
	"./id.js": 124,
	"./is": 125,
	"./is.js": 125,
	"./it": 126,
	"./it.js": 126,
	"./ja": 127,
	"./ja.js": 127,
	"./jv": 128,
	"./jv.js": 128,
	"./ka": 129,
	"./ka.js": 129,
	"./kk": 130,
	"./kk.js": 130,
	"./km": 131,
	"./km.js": 131,
	"./kn": 132,
	"./kn.js": 132,
	"./ko": 133,
	"./ko.js": 133,
	"./ku": 134,
	"./ku.js": 134,
	"./ky": 135,
	"./ky.js": 135,
	"./lb": 136,
	"./lb.js": 136,
	"./lo": 137,
	"./lo.js": 137,
	"./lt": 138,
	"./lt.js": 138,
	"./lv": 139,
	"./lv.js": 139,
	"./me": 140,
	"./me.js": 140,
	"./mi": 141,
	"./mi.js": 141,
	"./mk": 142,
	"./mk.js": 142,
	"./ml": 143,
	"./ml.js": 143,
	"./mn": 144,
	"./mn.js": 144,
	"./mr": 145,
	"./mr.js": 145,
	"./ms": 146,
	"./ms-my": 147,
	"./ms-my.js": 147,
	"./ms.js": 146,
	"./mt": 148,
	"./mt.js": 148,
	"./my": 149,
	"./my.js": 149,
	"./nb": 150,
	"./nb.js": 150,
	"./ne": 151,
	"./ne.js": 151,
	"./nl": 152,
	"./nl-be": 153,
	"./nl-be.js": 153,
	"./nl.js": 152,
	"./nn": 154,
	"./nn.js": 154,
	"./pa-in": 155,
	"./pa-in.js": 155,
	"./pl": 156,
	"./pl.js": 156,
	"./pt": 157,
	"./pt-br": 158,
	"./pt-br.js": 158,
	"./pt.js": 157,
	"./ro": 159,
	"./ro.js": 159,
	"./ru": 160,
	"./ru.js": 160,
	"./sd": 161,
	"./sd.js": 161,
	"./se": 162,
	"./se.js": 162,
	"./si": 163,
	"./si.js": 163,
	"./sk": 164,
	"./sk.js": 164,
	"./sl": 165,
	"./sl.js": 165,
	"./sq": 166,
	"./sq.js": 166,
	"./sr": 167,
	"./sr-cyrl": 168,
	"./sr-cyrl.js": 168,
	"./sr.js": 167,
	"./ss": 169,
	"./ss.js": 169,
	"./sv": 170,
	"./sv.js": 170,
	"./sw": 171,
	"./sw.js": 171,
	"./ta": 172,
	"./ta.js": 172,
	"./te": 173,
	"./te.js": 173,
	"./tet": 174,
	"./tet.js": 174,
	"./tg": 175,
	"./tg.js": 175,
	"./th": 176,
	"./th.js": 176,
	"./tl-ph": 177,
	"./tl-ph.js": 177,
	"./tlh": 178,
	"./tlh.js": 178,
	"./tr": 179,
	"./tr.js": 179,
	"./tzl": 180,
	"./tzl.js": 180,
	"./tzm": 181,
	"./tzm-latn": 182,
	"./tzm-latn.js": 182,
	"./tzm.js": 181,
	"./ug-cn": 183,
	"./ug-cn.js": 183,
	"./uk": 184,
	"./uk.js": 184,
	"./ur": 185,
	"./ur.js": 185,
	"./uz": 186,
	"./uz-latn": 187,
	"./uz-latn.js": 187,
	"./uz.js": 186,
	"./vi": 188,
	"./vi.js": 188,
	"./x-pseudo": 189,
	"./x-pseudo.js": 189,
	"./yo": 190,
	"./yo.js": 190,
	"./zh-cn": 191,
	"./zh-cn.js": 191,
	"./zh-hk": 192,
	"./zh-hk.js": 192,
	"./zh-tw": 193,
	"./zh-tw.js": 193
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block"},[_c('fa-icon',{attrs:{"icon":"calendar-alt"}}),_vm._v(" "+_vm._s(_vm.date)+" "),_c('fa-icon',{attrs:{"icon":"clock"}}),_vm._v(" "+_vm._s(_vm.time)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenSize_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19908153_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenSize_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenSize_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19908153_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenSize_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.sw)+"x"+_vm._s(_vm.sh))]),_vm._v(" "),_c('div',{staticClass:"d-inline-block d-sm-none"},[_vm._v("@xs")]),_vm._v(" "),_c('div',{staticClass:"d-none d-sm-inline-block d-md-none"},[_vm._v("@sm")]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-inline-block d-lg-none"},[_vm._v("@md")]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-inline-block d-xl-none"},[_vm._v("@lg")]),_vm._v(" "),_c('div',{staticClass:"d-none d-xl-inline-block"},[_vm._v("@xl")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"debug-wrapper"}},[(!_vm.hide)?_c('div',{staticClass:"small px-2 border border-primary border-top-0",attrs:{"id":"debug"}},[_c('div',[_vm._v("\n      connected at: "),_c('mz-date-display',{attrs:{"timestamp":_vm.connectedAt}})],1),_vm._v(" "),_c('div',[_vm._v("\n      updated at: "),_c('mz-date-display',{attrs:{"timestamp":_vm.updatedAt}})],1),_vm._v(" "),_c('div',[_vm._v("\n      disconnected at: "),_c('mz-date-display',{attrs:{"timestamp":_vm.disconnectedAt}})],1),_vm._v(" "),_c('div',[_c('mz-screen-size')],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-inline-block bg-primary rounded-bottom px-2 mb-0 pt-1"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggle($event)}}},[(!_vm.hide)?_c('fa-icon',{attrs:{"icon":"chevron-up"}}):_c('fa-icon',{attrs:{"icon":"chevron-down"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7907be28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7907be28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Controls_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a24dc19_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Controls_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Controls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a24dc19_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Controls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Connect_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295d29ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Connect_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Connect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295d29ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Connect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 290:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info my-2 my-sm-0",attrs:{"type":"submit","disabled":_vm.device.isConnecting},on:{"click":function($event){$event.preventDefault();return _vm.action($event)}}},[(_vm.device.isConnecting)?_c('fa-icon',{staticClass:"fa-spin",attrs:{"icon":_vm.spinner}}):_c('fa-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disconnect_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60952a12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disconnect_vue__ = __webpack_require__(294);
function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disconnect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60952a12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disconnect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger my-2 my-sm-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.action($event)}}},[_c('fa-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.device.connected)?_c('mz-connect',{attrs:{"device":_vm.device}}):_c('mz-disconnect',{attrs:{"device":_vm.device}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-dark navbar-expand-xs bg-dark",staticStyle:{"margin-left":"-15px","margin-right":"-15px"}},[_c('span',{staticClass:"navbar-brand mb-0 h1"},[_c('img',{staticStyle:{"width":"40px"},attrs:{"src":__webpack_require__(297)}}),_vm._v("\n    MOZYS Monitoring Dashboard\n    "),_c('span',{staticClass:"small text-secondary"},[_vm._v(_vm._s(_vm.version))])]),_vm._v(" "),_c('mz-controls')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('mz-debug'),_vm._v(" "),_c('mz-navbar'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(301);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkExactActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__["a" /* default */]
  }]
}));

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23416e74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23416e74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 302:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e6599a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e6599a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow-sm",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"card-header py-1 px-2"},[_c('fa-icon',{attrs:{"icon":"stethoscope"}}),_vm._v(" status\n  ")],1),_vm._v(" "),_c('div',{staticClass:"card-body text-center d-flex flex-column justify-content-center"},[_c('div',{staticClass:"status rounded mb-3 py-3",class:[ _vm.currentLevel === 0 ? 'status-success' : 'status-default' ]},[_c('fa-icon',{attrs:{"icon":"check"}}),_vm._v(" OK\n    ")],1),_vm._v(" "),_c('div',{staticClass:"status rounded mb-3 py-3",class:[ _vm.currentLevel === 1 ? 'status-warning' : 'status-default' ]},[_c('fa-icon',{attrs:{"icon":"exclamation"}}),_vm._v(" WARN\n    ")],1),_vm._v(" "),_c('div',{staticClass:"status rounded py-3",class:[ _vm.currentLevel === 2 ? 'status-danger' : 'status-default' ]},[_c('fa-icon',{attrs:{"icon":"wrench"}}),_vm._v(" ALARM\n    ")],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lifetime_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b762200_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lifetime_vue__ = __webpack_require__(348);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lifetime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b762200_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lifetime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow-sm"},[_c('div',{staticClass:"card-header py-1 px-2"},[_c('fa-icon',{attrs:{"icon":"heartbeat"}}),_vm._v(" lifetime [%]\n  ")],1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"display-1",staticStyle:{"font-size":"7.5rem","position":"absolute","left":"50%","top":"50%","transform":"translate(-50%, -50%)"}},[_vm._v("\n      "+_vm._s(Math.min(Math.round(_vm.currentLife), 100) || '')+"\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-placehoder",attrs:{"id":"lifetime-chart-placeholder"}},[_c('canvas',{attrs:{"id":"lifetime-chart-area","width":"100","height":"100"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vibration_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d09ee6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vibration_vue__ = __webpack_require__(350);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vibration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d09ee6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vibration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow-sm"},[_c('div',{staticClass:"card-header py-1 px-2"},[_c('fa-icon',{attrs:{"icon":"heart-rate"}}),_vm._v(" vibration [g]\n  ")],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"chart-placehoder",attrs:{"id":"vib-chart-placeholder"}},[_c('canvas',{attrs:{"id":"vib-chart-area","width":"250","height":"100"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Temperature_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771325e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Temperature_vue__ = __webpack_require__(352);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Temperature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771325e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Temperature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow-sm"},[_c('div',{staticClass:"card-header py-1 px-2"},[_c('fa-icon',{attrs:{"icon":"thermometer-half"}}),_vm._v(" temperature [°C]\n  ")],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"chart-placehoder",attrs:{"id":"temp-chart-placeholder"}},[_c('canvas',{attrs:{"id":"temp-chart-area","width":"250","height":"100"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row bg-light pt-3 d-flex align-items-stretch"},[_c('div',{staticClass:"col"},[_c('mz-status')],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('mz-lifetime')],1)]),_vm._v(" "),_c('div',{staticClass:"row bg-light pt-3"},[_c('div',{staticClass:"col"},[_c('mz-vibration')],1)]),_vm._v(" "),_c('div',{staticClass:"row bg-light pt-3"},[_c('div',{staticClass:"col"},[_c('mz-temperature')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);


var version = __webpack_require__(355);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  version: version.tag,
  connected: null,
  connectedAt: null,
  disconnectedAt: null,
  updatedAt: null,
  thresh: {
    life: [70, 90],
    vib: [1.2, 1.5],
    temp: [35, 40]
  },
  level: {
    life: 0,
    vib: 0,
    temp: 0
  },
  currentLevel: null,
  history: {
    life: [],
    vib: [],
    temp: []
  },
  totalPoints: 20,
  colors: {
    light: '#f5f5f7',
    dark: '#333b40',
    secondary: '#cdc7c5',
    primary: '#f29000',
    info: '#0070e0',
    warning: '#ffff66',
    success: '#8ffbaf',
    danger: '#db3645',
    darkinfo: '#24406b',
    darksuccess: '#009303',
    darkdanger: '#a1210a',
    darkwarning: '#ffcb00',
    darkgrey: '#cdc7c5'
  }
};

var getters = {
  connected: function connected(state) {
    return state.connected;
  },
  version: function version(state) {
    return state.version;
  },
  colors: function colors(state) {
    return state.colors;
  },
  levelColors: function levelColors(state) {
    return [state.colors.success, state.colors.warning, state.colors.danger];
  },
  thresh: function thresh(state) {
    return state.thresh;
  },
  history: function history(state) {
    return state.history;
  },
  totalPoints: function totalPoints(state) {
    return state.totalPoints;
  },
  currentLife: function currentLife(state) {
    return state.history.life.slice(-1)[0];
  },
  currentVib: function currentVib(state) {
    var lastElement = state.history.vib.slice(-1)[0];
    return lastElement && lastElement.y;
  },
  currentLevel: function currentLevel(state) {
    return state.currentLevel;
  },
  level: function level(state) {
    return state.level;
  }
};

var mutations = {
  setConnected: function setConnected(state, payload) {
    state.connected = payload;
  },
  updateHistory: function updateHistory(state, payload) {
    state.history[payload.tag].push(payload.point);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.history, payload.tag, state.history[payload.tag].slice(-state.totalPoints));

    var thresh = state.thresh[payload.tag];

    var level = 0;
    if (payload.point.y > thresh[1]) {
      level = 2;
    } else if (payload.point.y > thresh[0]) {
      level = 1;
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.level, payload.tag, level);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentLevel', Math.max(state.level.life, state.level.vib, state.level.temp));
  },
  updateLife: function updateLife(state, payload) {
    var scl = 1.0;

    var currentLife = payload.currentLife || 0;
    var currentVib = payload.currentVib || 0;
    var thresh = state.thresh.life;

    var level = 0;
    if (currentLife > thresh[1]) {
      level = 2;
      scl = 2.0;
    } else if (currentLife > thresh[0]) {
      level = 1;
      scl = 1.5;
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.level, 'life', level);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'currentLevel', Math.max(state.level.life, state.level.vib, state.level.temp));

    var newLife = currentLife + scl * Math.pow(currentVib, 2);
    if (newLife > 120) {
      newLife = 0;
    }

    state.history.life.push(newLife);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.history, 'life', state.history.life.slice(-state.totalPoints));
  }
};

var actions = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

module.exports = {"tag":"v0.0.2-4-g6e324bf"}

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Debug__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__(281);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  components: {
    mzDebug: __WEBPACK_IMPORTED_MODULE_0__components_Debug__["a" /* default */],
    mzNavbar: __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */]
  }
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DateDisplay__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ScreenSize__ = __webpack_require__(277);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'debug',
  data: function data() {
    return {
      hide: true
    };
  },

  computed: {
    updatedAt: function updatedAt() {
      return this.$store.state.updatedAt;
    },
    connectedAt: function connectedAt() {
      return this.$store.state.connectedAt;
    },
    disconnectedAt: function disconnectedAt() {
      return this.$store.state.disconnectedAt;
    }
  },
  methods: {
    toggle: function toggle() {
      this.hide = !this.hide;
    }
  },
  components: {
    mzDateDisplay: __WEBPACK_IMPORTED_MODULE_0__components_DateDisplay__["a" /* default */],
    mzScreenSize: __WEBPACK_IMPORTED_MODULE_1__components_ScreenSize__["a" /* default */]
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dateDisplay',
  props: {
    timestamp: {
      type: Number,
      default: Date.now()
    },
    dateFormat: {
      type: String,
      default: 'MMMM Do YYYY'
    },
    timeFormat: {
      type: String,
      default: 'HH:mm:ss'
    }
  },
  computed: {
    date: function date() {
      return this.timestamp ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.timestamp).format(this.dateFormat) : '?';
    },
    time: function time() {
      return this.timestamp ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.timestamp).format(this.timeFormat) : '?';
    }
  }
});

/***/ })

},[214]);


// WEBPACK FOOTER //
// static/js/app.366913216abc8c3f26b3.js